function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "repsyps");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M144.89,36.15l-3.78,0c-9,0-11.65-.06-13.55,1.83a6.36,6.36,0,0,0-1.51,2.47c-2.9,17.15-6.17,31-9.07,48.12a3.8,3.8,0,0,0,.27,2.21h0a5.32,5.32,0,0,0,1,1.23c3.44,3,9.25,1.52,18.92.45,1.86-.2,4.57-.24,7.9-.23,3.1.11,5.59.17,7.18.36,9.41,1.12,14.74,2.21,17.89-.58a5.45,5.45,0,0,0,1-1.23h0a3.74,3.74,0,0,0,.28-2.21c-2.91-17.14-6.17-31-9.08-48.12a6.49,6.49,0,0,0-1.5-2.47c-1.91-1.89-4.57-1.79-13.56-1.83l-3.78,0",
  transform: "translate(-5.45 -3.79)",
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 7
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M51.33,196.12c.37.62,1.05,1.79,1.91,3.26,4.52,7.76,5.77,10.12,8.36,10.82a6.26,6.26,0,0,0,2.89.07c16.31-6.06,29.91-10.14,46.22-16.19a3.77,3.77,0,0,0,1.77-1.34h0a5.85,5.85,0,0,0,.55-1.5c.91-4.5-3.31-8.78-9.07-16.63-1.1-1.5-2.49-3.83-4.14-6.71-1.46-2.74-2.65-4.93-3.28-6.4-3.73-8.72-5.45-13.87-9.45-15.21a5.63,5.63,0,0,0-1.58-.27h0a3.72,3.72,0,0,0-2,.86C70.07,158,59.73,167.71,46.33,178.8a6.24,6.24,0,0,0-1.39,2.54c-.69,2.6.73,4.85,5.19,12.65.84,1.48,1.52,2.66,1.87,3.29",
  transform: "translate(-5.45 -3.79)",
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 7
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M237.71,197.24c.35-.63,1-1.81,1.86-3.29,4.45-7.81,5.87-10.06,5.17-12.66a6.3,6.3,0,0,0-1.39-2.54c-13.42-11.06-23.77-20.79-37.19-31.85a3.76,3.76,0,0,0-2-.86h0a5.08,5.08,0,0,0-1.57.28c-4.35,1.47-5.94,7.26-9.84,16.17a75.06,75.06,0,0,1-3.73,7c-1.63,2.64-2.93,4.76-3.89,6.05-5.67,7.6-9.26,11.67-8.41,15.8a5.57,5.57,0,0,0,.55,1.5h0a3.79,3.79,0,0,0,1.78,1.34c16.31,6,29.92,10.09,46.24,16.12a6.23,6.23,0,0,0,2.89-.08c2.59-.7,3.83-3.06,8.34-10.83.86-1.48,1.54-2.65,1.91-3.27",
  transform: "translate(-5.45 -3.79)",
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 7
});

var _ref6 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 138.77,
  cy: 138.77,
  r: 30.67,
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 7
});

var _ref7 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 138.77,
  cy: 138.77,
  r: 135.27,
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 7
});

var SvgRepsyps = function SvgRepsyps(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "f3bba0ae-2ca5-41b9-8d69-98aeda316fde",
    "data-name": "Layer 1",
    viewBox: "0 0 277.54 277.54",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgRepsyps, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/repsyps.a6ff6c31.svg";
export { ForwardRef as ReactComponent };